<template>
	<v-card class="mb-1">
		<v-card-title class="text-subtitle-1">
			{{email.description}}
			<v-spacer></v-spacer>
			<v-btn v-if="!email.automatic && !isSMS" icon @click="deleteEmail" :loading="loadingDeleteEmail">
				<v-icon color="primary">mdi-delete</v-icon>
			</v-btn>
			<v-btn class="ml-1" icon @click="showEdit = true">
				<v-icon color="primary">mdi-pencil</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
		<p class="text-h7 mt-2"><b>Email</b></p>
		<div v-html="email.subject_pt" />
		<div v-html="email.body_pt" />
		<template v-if="isSMS">
			<p class="text-h7 mt-3"><b>SMS</b></p>
			<div v-html="email.sms_pt" />
		</template>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn v-if="!isSMS" color="primary darken-1" text @click="$emit('open-send-email', email)">
				Enviar
			</v-btn>
		</v-card-actions>
		<v-dialog v-model="showEdit" max-width="70%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<EmailForm ref="emailForm" :email="email" :isSMS="isSMS" />
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEdit = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editEmail">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import EmailForm from "@/components/admin/EmailForm"
import axios from "axios";

export default {
	name: "Email",
	props: ["email", "isSMS"],
	components: {
		EmailForm
	},
	data: () => ({
		showEdit: false,
		loadingDeleteEmail: false
	}),
	methods: {
		editEmail() {
			let form = this.$refs.emailForm.getForm();
			if(form) {
				axios
					.post("/admin/emails/" + this.email.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.$emit("edit-email", response.data.email);
							this.showEdit = false;
						}
					})
					.catch(error => console.log(error));
			}
		},
		deleteEmail() {
			this.loadingDeleteEmail = true;
			axios
				.post("/admin/emails/" + this.email.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "ok") {
						this.$emit("delete-email");
					}
					this.loadingDeleteEmail = false;
				})
				.catch(error => {
					console.log(error);
					this.loadingDeleteEmail = false;
				});
		}
	}
}
</script>